import React, { PureComponent } from "react";
import { Col } from "reactstrap";
import { Field, reduxForm } from "redux-form";
import PropTypes from "prop-types";
import renderSelectField from "../../../../shared/components/form/Select";
import * as configs from "./config";

class HorizontalForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.initialize(this.props.edit());
    this.setState(this.props.edit(), () => this.props.handleForm(this.state));
  }

  cancelCreation = () => {
    this.props.reset();
    this.props.cancelCreation();
  };

  formChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    this.setState({ [nam]: val }, () => {
      this.props.handleForm(this.state);
    });
  };

  printInput = (input) => {
    switch (input.key) {
      case "type":
        return (
          <Field
            name={input.key}
            component={renderSelectField}
            options={configs.types}
            onChange={(event) => {
              this.setState({ type: event.value }, () => {
                this.props.handleForm(this.state);
              });
            }}
          />
        );
      case "state":
        return (
          <Field
            name={input.key}
            component={renderSelectField}
            options={configs.state}
            onChange={(event) => {
              this.setState({ state: event.value }, () => {
                this.props.handleForm(this.state);
              });
            }}
          />
        );
      default:
        return (
          <Field
            name={input.key}
            component="input"
            type={input.type}
            placeholder={input.name}
            onKeyUp={this.formChangeHandler}
          />
        );
    }
  };

  render() {
    const { handleSubmit } = this.props;

    return (
      <Col md={12} lg={12}>
        <div className="card__title">
          <h5 className="bold-text">{this.props.title}</h5>
        </div>
        <form
          autoComplete="off"
          className="form form--horizontal"
          onSubmit={handleSubmit}
        >
          {configs.columnHeader.map((input) =>
            !input.system &&
            (this.props.edit().lid === undefined ||
              (this.props.edit().lid !== undefined && input.key !== "id")) ? (
              <div className="form__form-group">
                <span className="form__form-group-label">{input.name}</span>
                <div className="form__form-group-field">
                  {this.printInput(input)}
                </div>
              </div>
            ) : (
              ""
            )
          )}
        </form>
      </Col>
    );
  }
}

export default reduxForm({
  form: "proxy_nodes_form", // a unique identifier for this form
})(HorizontalForm);
